import { render } from "./LeftsideBar.vue?vue&type=template&id=1067b416"
import script from "./LeftsideBar.vue?vue&type=script&lang=js"
export * from "./LeftsideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__